/* eslint-disable react-hooks/exhaustive-deps */
import { useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";
import { VERIFY_EMAIL } from "./apollo/gql/query/user.query";
import { useModalAction } from "./components/modal/modal.context";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { routes } from "./routes";
import { useRecoilState } from 'recoil';

import dayjs from 'dayjs';
import "./pages/Home/style.scss";

import 'dayjs/locale/zh-cn';

import updateLocale from 'dayjs/plugin/updateLocale';
import weekday from "dayjs/plugin/weekday"
import localeData from "dayjs/plugin/localeData"
import { alankaramDataAtom } from "./state";
import { alankaramConstant } from "./constant";
import useCompanyId from "./hooks/useCompanyId";
import { changeFavicon } from "./utils/changeFavicon";
import { loadGtag } from "./utils/loadGtag";

declare global {
  interface Window {
    webpSupport?: boolean;
  }
}

const AppRoutes = () => {
  const element = useRoutes(routes);
  return element;
};

const App = () => {
  const [loading, setLoading] = useState(false);
  var token = new URLSearchParams(window.location.search).get('token');
  const [AlankaramData, setAlankaramData] = useRecoilState(alankaramDataAtom);
  const companyId = useCompanyId()

  useEffect(() => {
      changeFavicon(AlankaramData?.favicon);
      loadGtag(AlankaramData?.GTAG_ID)
  }, [AlankaramData]);

  useEffect(() => {
    const currentHost = window.location.host;
    const matchedCompany: any = alankaramConstant?.find(company =>
      company.domain.includes(currentHost)
    );

    if (matchedCompany) {
      setAlankaramData(matchedCompany);
    }
  }, []);

  useEffect(() => {
    if (AlankaramData?.title) {
      document.title = AlankaramData.title;
    }
  }, [AlankaramData]);

  const [verifyEmailMutation] = useMutation(VERIFY_EMAIL)
  const { openModal, closeModal } = useModalAction();
  const accessToken = localStorage.getItem('access-token');

  const checkWebPSupport = () => {
    let elem = document.createElement('canvas');
    if (!!(elem.getContext && elem.getContext('2d'))) {
      window.webpSupport = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } else {
      window.webpSupport = false;
    }
  }

  useEffect(() => {
    checkWebPSupport()
    const path = window?.location?.pathname;
    const verifyEmailAndSignIn = async () => {
      try {
        closeModal();
        setLoading(true)
        // Verify the email
        const response = await verifyEmailMutation({ variables: { code: token, companyId: companyId } });
        await toast.success('Login successfully');
        setLoading(false)
        localStorage.setItem('access-token', response?.data?.verifyEmail?.token);
        localStorage.setItem('userData', JSON?.stringify(response?.data?.verifyEmail?.user))
        window.location.assign("/");
      } catch (error: any) {
        toast.error(error?.message);
        setLoading(false)
        openModal('LOGIN')
      }
    };


    if (path?.includes('/verify-email')) {
      verifyEmailAndSignIn();
      return;
    }

    if (accessToken || path?.includes('/project/') || path?.includes('/ar_view/')) {
      closeModal();
      return;
    }

    // Only run one of these
    switch (path) {
      case '/reset-password':
        openModal('CREATE_PASSWORD');
        break;
      case '/forgotpassword':
        openModal('FORGOT_PASSWORD');
        break;
      case '/signup':
        openModal('REGISTER');
        break;
      default:
        openModal('LOGIN');
        break;
    }

  }, []);

  dayjs.extend(updateLocale);
  dayjs.updateLocale('zh-cn', {
    weekStart: 0,
  });
  dayjs.extend(weekday)
  dayjs.extend(localeData)

  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <Spinner />
        </div>
      ) : (
        <div className="App">
          <AppRoutes />
        </div>
      )}
    </>
  );
}

export default App;